import Token from '@/utils/Token';

export default {
    regras(modulo, params = '') {
        if (params) {
            params = `?${params}`;
        }
        return axios.get(`/api/integridade/regras/${modulo}${params}`, Token.getHeader());
    },
    auditoria(modulo, params = '') {
        if (params) {
            params = `?${params}`;
        }
        return axios.get(`/api/integridade/auditoria/${modulo}${params}`, Token.getHeader());
    },
};
